import { InjectionToken } from "@angular/core";
import { OktaConfig } from "@okta/okta-angular";

export const OKTA_CONFIG = new InjectionToken<OktaConfig>(
  "okta.config.angular"
);
